import React from 'react'
import { InputSwitch } from 'primereact/inputswitch'
import { Button } from 'primereact/button'

const HistoriqueColumnSelector = ({ 
  columns, 
  visibleColumns, 
  onColumnChange,
  hasDoorData
}) => {
  const handleToggle = (column) => {
    const isVisible = visibleColumns.some(col => col.field === column.field)
    
    if (isVisible) {
      onColumnChange(visibleColumns.filter(col => col.field !== column.field))
    } else {
      onColumnChange([...visibleColumns, column])
    }
  }

  // Filtrer les colonnes de porte si pas de données disponibles
  const availableColumns = columns.filter(column => {
    if ((column.field === 'porte1Ouvert' || column.field === 'porte2Ouvert') && !hasDoorData) {
      return false
    }
    return true
  })

  return (
    <div style={{ minWidth: 280 }}>
      <div className="flex align-items-center gap-2 mb-3">
        <i className="pi pi-table text-primary"></i>
        <h3 className="m-0 text-900">Configuration des Colonnes</h3>
      </div>
      
      {/* Colonnes Section */}
      <div className="mb-4">
        <div className="font-semibold mb-3 text-700">Colonnes visibles</div>
        <div className="flex flex-column gap-3">
          {availableColumns.map((column) => {
            const isVisible = visibleColumns.some(col => col.field === column.field)
            
            return (
              <div key={column.field} className="flex align-items-center gap-3 p-2 hover:surface-100 border-round transition-colors transition-duration-150">
                <InputSwitch 
                  inputId={`column-${column.field}`}
                  checked={isVisible}
                  onChange={() => handleToggle(column)}
                />
                <label htmlFor={`column-${column.field}`} className="cursor-pointer flex-1 text-900">
                  {column.header}
                </label>
                {column.field === 'timestamp' && (
                  <i className="pi pi-lock text-400" title="Colonne obligatoire"></i>
                )}
              </div>
            )
          })}
        </div>
      </div>

      {/* Actions */}
      <div className="flex flex-column gap-2">
        <Button 
          label="Réinitialiser"
          icon="pi pi-refresh"
          className="p-button-outlined p-button-sm"
          onClick={() => onColumnChange(availableColumns.filter(col => col.defaultVisible))}
        />
        <Button 
          label="Tout afficher"
          icon="pi pi-eye"
          className="p-button-outlined p-button-sm"
          onClick={() => onColumnChange(availableColumns)}
        />
        <Button 
          label="Tout masquer"
          icon="pi pi-eye-slash"
          className="p-button-outlined p-button-sm"
          onClick={() => onColumnChange(availableColumns.filter(col => col.field === 'timestamp'))}
        />
      </div>

      {/* Info */}
      <div className="mt-4 p-3 bg-blue-50 border-round border-1 border-blue-200">
        <div className="flex align-items-start gap-2">
          <i className="pi pi-info-circle text-blue-500 mt-1"></i>
          <div className="text-blue-700 text-sm">
            <p className="m-0 font-semibold mb-1">Informations :</p>
            <ul className="m-0 pl-3 text-xs">
              <li>L'horodatage est toujours visible</li>
              <li>Les préférences sont sauvegardées automatiquement</li>
              {!hasDoorData && <li>Les colonnes de porte sont masquées (pas de données)</li>}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HistoriqueColumnSelector
